import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { CurrencyInputComponent } from 'src/app/shared/currency-input/currency-input.component';
import { CustomAmountSettings } from '../../design-and-amount-settings';
import { GiftCardPurchaseFormService } from '../../gift-card-purchase-form/gift-card-purchase-form.service';

const selector = 'ols-amount-selection';

@Component({
    selector: selector,
    templateUrl: './amount-selection.component.html',
    styleUrls: ['./amount-selection.component.scss'],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
})
export class AmountSelectionComponent {
    @Input() suggestedAmounts: number[];
    @Input() customAmountSettings: CustomAmountSettings;

    @ViewChild('customAmountButtonInput')
    customAmountButtonInput: CurrencyInputComponent;

    get selectedItemTotal() {
        return this.formService.itemTotal;
    }

    get customAmountDropDownValue() {
        return -1;
    }

    get selector() {
        return selector;
    }

    private currentWindowWidth = window.innerWidth;

    constructor(private formService: GiftCardPurchaseFormService) {}

    @HostListener('window:resize')
    onResize() {
        this.currentWindowWidth = window.innerWidth;
    }

    isDropDownVisible(): boolean {
        return this.currentWindowWidth < 825;
    }

    selectedItemTotalChanged(newTotal: number) {
        if (!isNaN(newTotal)) {
            this.selectedItemTotal.setValue(newTotal);
        } else {
            this.selectedItemTotal.setValue('');
        }

        this.formService.setItemTotalValidators(
            this.customAmountSettings,
            this.suggestedAmounts
        );
    }

    customAmountClicked() {
        this.customAmountButtonInput.focus();
        this.selectedItemTotal.markAsUntouched();

        if (this.isSuggestedAmount(this.selectedItemTotal.value)) {
            this.selectedItemTotalChanged(null);
        }
    }

    isCustomAmountSelected(): boolean {
        return (
            !this.selectedItemTotal.value?.toString().length ||
            !this.isSuggestedAmount(this.selectedItemTotal.value)
        );
    }

    amountInputBlurred() {
        //Timeout needed to prevent validation error from flashing when a suggested amount is clicked
        setTimeout(() => {
            this.selectedItemTotal.markAsTouched();
        }, 100);
    }

    getCustomAmount(): number {
        const selectedItemTotal = parseFloat(this.selectedItemTotal.value);

        return this.isCustomAmountSelected() && !isNaN(selectedItemTotal)
            ? selectedItemTotal
            : null;
    }

    isSuggestedAmount(amount: string): boolean {
        return this.suggestedAmounts.map((x) => x.toString()).includes(amount);
    }

    hasFocus(element: Element) {
        return document.activeElement === element;
    }

    submitForm() {
        this.formService.submitForm();
    }
}
